import React, { useEffect, useRef, useState } from 'react'


import styles from '../../css/style.module.css'


import HOC from '../../components/HOC/HOC'
import { Link, useNavigate } from 'react-router-dom';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'


import { FaPlus } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
const columns = [
    'S.no',
    'Title',
    'Image',
    'Mobile Number',
    'Email',
    'Address',
    'Action'
];

const ContactDetailsOffice = () => {
    const navigate = useNavigate()
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [selecteddata, setSelectedData] = useState(null);
    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);


    const fetchData = async () => {
        await getApi(endPoints.getContactDetailsOffice, {
            setResponse: setData,
            setLoading,
            errorMsg: 'Failed to fetch data!'
        });;
    };


    useEffect(() => {
        fetchData();
    }, [])


    const handleDelete = async () => {
        if (!selecteddata) return;

        await deleteApi(endPoints.deletecontactdetails(selecteddata), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete data!'
        });

        fetchData();
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        setTimeout(() => setShowSuccessModal(false), 2000);
    };

    const openDeleteModal = (categoryId) => {
        setSelectedData(categoryId);
        setShowDeleteModal(true);
    };


    const routeMapping = {
        'Contact details': "/contact-details",
        'Contact Details Office': "/contact-details/office",
    };



    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="delete this contact details"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Contact Details For Office</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={() => navigate('/contact-details/office/add')}>
                            <FaPlus color='#FFFFFF' />
                            <p>Add New</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Contact details', 'Contact Details Office'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'Contact Details Office'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            <img src={img2} alt="Loading" width={100} height={100} />
                                        </td>
                                    </tr>
                                ) : (!data?.data || Object.keys(data.data).length === 0) ? (
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            No data available.
                                        </td>
                                    </tr>
                                ) : (
                                    data?.data?.map((item, rowIndex) => (
                                        <tr key={rowIndex} className={styles.tableRow}>
                                            <td className={styles.tableCell}>{rowIndex + 1}</td>
                                            <td className={styles.tableCell}>{item.title || "N/A"}</td>
                                            <td className={styles.tableCell}>
                                                <div className={styles.tabledocument}>
                                                    <img src={item.image} alt="" />
                                                </div>
                                            </td>
                                            <td className={styles.tableCell}>{item.mobileNumber || "N/A"}</td>
                                            <td className={styles.tableCell}>{item.email || "Uncategorized"}</td>
                                            <td className={styles.tableCell}>{item.address || "Uncategorized"}</td>
                                            <td>
                                                <div className={styles.tableaction}>
                                                    <Link to={`/contact-details/office/edit/${item?._id}`}>
                                                        <FaRegEdit size={20} color="#e9b44a" />
                                                    </Link>
                                                    <RiDeleteBin6Line
                                                        size={20}
                                                        onClick={() => openDeleteModal(item._id)}
                                                        style={{ cursor: "pointer", color: "#d9534f" }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div >
        </>
    )
}

export default HOC(ContactDetailsOffice)
